export var localizations = {
  name: {
    en: "Block Puzzle: Smart Placement",
    ru: "Block Puzzle: Умное Размещение",
    zh: "方块拼图：智能放置",
    uz: "Blok Boshqotirma: Aqlli Joylashtirish",
    tr: "Blok Bulmaca: Akıllı Yerleştirme",
    pt: "Quebra-Cabeça de Blocos: Posicionamento Inteligente",
    pl: "Układanka Klocków: Inteligentne Układanie",
    nl: "Blokpuzzel: Slimme Plaatsing",
    kk: "Блокты Басқатырғыш: Ақылды Орналастыру",
    ja: "ブロックパズル：スマート配置",
    it: "Puzzle di Blocchi: Posizionamento Intelligente",
    id: "Teka-Teki Blok: Penempatan Cerdas",
    hi: "ब्लॉक पहेली: स्मार्ट प्लेसमेंट",
    fr: "Puzzle de Blocs : Placement Intelligent",
    es: "Rompecabezas de Bloques: Colocación Inteligente",
    de: "Blockpuzzle: Clevere Platzierung",
  },
  gameOverTitle: {
    en: "Congratulations!",
    ru: "Поздравляю!",
    zh: "恭喜！",
    uz: "Tabriklar!",
    tr: "Tebrikler!",
    pt: "Parabéns!",
    pl: "Gratulacje!",
    nl: "Gefeliciteerd!",
    kk: "Құттықтаймын!",
    ja: "おめでとう！",
    it: "Congratulazioni!",
    id: "Selamat!",
    hi: "बधाई!",
    fr: "Félicitations!",
    es: "¡Felicidades!",
    de: "Glückwunsch!",
  },
  score: {
    en: "Score",
    ru: "Счёт",
    zh: "分数",
    uz: "Ball",
    tr: "Skor",
    pt: "Pontuação",
    pl: "Wynik",
    nl: "Score",
    kk: "Ұпай",
    ja: "スコア",
    it: "Punteggio",
    id: "Skor",
    hi: "स्कोर",
    fr: "Score",
    es: "Puntuación",
    de: "Punktzahl",
  },
  restart: {
    en: "Start over",
    ru: "Начать сначала",
    zh: "重新开始",
    uz: "Qaytadan boshlash",
    tr: "Baştan başla",
    pt: "Recomeçar",
    pl: "Zacznij od nowa",
    nl: "Opnieuw beginnen",
    kk: "Қайта бастау",
    ja: "最初からやり直す",
    it: "Ricomincia",
    id: "Mulai ulang",
    hi: "फिर से शुरू करें",
    fr: "Recommencer",
    es: "Empezar de nuevo",
    de: "Neu starten",
  },
  resize: {
    en: "Choose a size!",
    ru: "Выберите размер!",
    zh: "选择尺寸！",
    uz: "Hajmni tanlang!",
    tr: "Boyut seç!",
    pt: "Escolha um tamanho!",
    pl: "Wybierz rozmiar!",
    nl: "Kies een maat!",
    kk: "Өлшемді таңдаңыз!",
    ja: "サイズを選んで！",
    it: "Scegli una dimensione!",
    id: "Pilih ukuran!",
    hi: "आकार चुनें!",
    fr: "Choisissez une taille !",
    es: "¡Elige un tamaño!",
    de: "Wähle eine Größe!",
  },
  close: {
    en: "Close",
    ru: "Закрыть",
    zh: "关闭",
    uz: "Yopish",
    tr: "Kapat",
    pt: "Fechar",
    pl: "Zamknij",
    nl: "Sluiten",
    kk: "Жабу",
    ja: "閉じる",
    it: "Chiudi",
    id: "Tutup",
    hi: "बंद करें",
    fr: "Fermer",
    es: "Cerrar",
    de: "Schließen",
  },
  chooseSize: {
    en: "Choose a size",
    ru: "Выбрать размер",
    zh: "选择尺寸",
    uz: "Hajmni tanlash",
    tr: "Boyut seç",
    pt: "Escolher tamanho",
    pl: "Wybierz rozmiar",
    nl: "Kies een maat",
    kk: "Өлшемді таңдау",
    ja: "サイズを選択",
    it: "Scegli una dimensione",
    id: "Pilih ukuran",
    hi: "आकार चुनें",
    fr: "Choisir une taille",
    es: "Elegir un tamaño",
    de: "Eine Größe wählen",
  },
};

export var getLanguage = function () {
  if (!window.ysdk) {
    return "en";
  } else {
    var language = window.ysdk.environment.i18n.lang;
    var supportedLanguages = [
      "en",
      "ru",
      "es",
      "de",
      "tr",
      "id",
      "hi",
      "fr",
      "zh",
      "pt",
      "ja",
      "it",
      "pl",
      "uz",
      "nl",
      "kk",
    ];
    return supportedLanguages.includes(language) ? language : "en";
  }
};
